import type { Languages } from '@s4l/i18n/types/Languages'
import type { Config } from '../../_config'
import { FactoryHeader } from '../../_headers/FactoryHeaders'
import { Language } from '../domain/Language'
import { ForbiddenSharedRepository } from './ForbiddenSharedRepository'

export class HeaderSharedRepository extends ForbiddenSharedRepository {
  static create({ config }: { config: Config }) {
    return new HeaderSharedRepository(config)
  }

  constructor(config: Config) {
    super(config)
  }

  async language() {
    const header = await FactoryHeader.create({ config: this.config }).header()

    const [error, acceptedLanguage] = header.getAcceptedLanguages<Languages>()

    if (error) return Language.empty()
    if (acceptedLanguage.localeWithRegion) {
      const locale = Language.createOrEmpty({
        value: acceptedLanguage.localeWithRegion.replace('-', '_') as Languages,
      })

      if (!locale.isEmpty()) return locale
    }

    if (!acceptedLanguage.locale) return Language.empty()

    return Language.create({ value: acceptedLanguage.locale })
  }
}
